var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_2620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6.3374V14.1499",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08105 21.181C5.83149 19.9821 6.85722 18.9971 8.06533 18.3153C9.27345 17.6334 10.6258 17.2764 11.9998 17.2764C13.3738 17.2764 14.7262 17.6334 15.9343 18.3153C17.1424 18.9971 18.1681 19.9821 18.9186 21.181",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.3374L12 9.4624L3 6.3374L12 3.2124L21 6.3374Z",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 8.11475C16.5599 8.89734 17.0144 9.87153 17.1801 10.9186C17.3458 11.9656 17.2155 13.0402 16.805 14.0114C16.3946 14.9826 15.7218 15.8085 14.8686 16.3883C14.0154 16.9681 13.0187 17.2768 12 17.2768C10.9813 17.2768 9.9846 16.9681 9.13141 16.3883C8.27822 15.8085 7.6054 14.9826 7.19497 14.0114C6.78453 13.0402 6.65422 11.9656 6.81991 10.9186C6.98561 9.87153 7.44015 8.89734 8.12813 8.11475",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_2620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white",
    transform: "translate(0 0.0874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.18da715e6fea0e4b0e037492171abb21.svg";
export { ForwardRef as ReactComponent };